export default "__VITE_ASSET__d18b7297__"